import React from 'react';
import { Component } from 'react';
import "./SignUpPage.scss";
import SignUpScreen from '../../components/screens/SignUp/SignUpScreen';

type SignUpPageProps = {
};

export default class SignUpPage extends Component<SignUpPageProps> {
    public render() {
        return (
            <div>
                <div className="background"></div>
                <div className="web-container sign-up">

                    <section id="sign-up">
                        <SignUpScreen />
                    </section>

                </div>
            </div>
        )
    }
}